import { render, staticRenderFns } from "./TeamIcon.vue?vue&type=template&id=5099a206&"
import script from "./TeamIcon.vue?vue&type=script&lang=js&"
export * from "./TeamIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports